import { FaberApi } from 'api'
import { AxiosPromise } from 'axios'
import { EsimInventoryTypeV2 } from 'types/api/faber/inventory.type'
import {
  FulfillmentGetDataBase,
  InventoryGetDataBase
} from 'types/api/faber/inventory.type'

class InventoryAPI {
  /**
   * to get the list of esim inventories
   * @param count
   * @param offset
   * @returns
   */
  static getEsimInventory(
    count = 1000,
    offset = 0,
    faberToken: string
  ): AxiosPromise<InventoryGetDataBase> {
    return FaberApi.httpGet(
      `/esim/inventories?count=${count}&offset=${offset}`,
      { Authorization: `Bearer ${faberToken}` }
    )
  }
  /**
   * to get the fulfilment list
   * @param count
   * @param offset
   * @returns
   */
  static getEsimFulfilments(
    count = 1000,
    offset = 0,
    faberToken: string
  ): AxiosPromise<FulfillmentGetDataBase> {
    return FaberApi.httpGet(
      `/esim/fulfillments?count=${count}&offset=${offset}`,
      { Authorization: `Bearer ${faberToken}` }
    )
  }

  /**
   * to update inventory status
   * @param iccidObj
   * @returns Promise<AxiosResponse<any, any>>
   */
  static updateEsimInventory(iccidObj) {
    return FaberApi.httpPut(
      `/esim/${iccidObj.iccid}/status`,
      { Authorization: `Bearer ${iccidObj.faberToken}` },
      {
        iccidStatus: iccidObj.status
      }
    )
  }

  /**
   * to insert telna csv
   * @param uploadObject
   * @returns
   */
  static uploadTelnaCSV({faberToken, payload}) {
    return FaberApi.httpPost(
      `/sim/ops/esim/restock`,
      { Authorization: `Bearer ${faberToken}` },
      payload
    )
  }

  // new endpoint to get esim inventories for CH dashboard
  static getEsimInventoryV2(
    offset = 0,
    limit = 10,
    faberToken: string,
    statuses?: string[], //AVAILABLE,PROVISIONED,TERMINATED // please provide in this format (i.e. "string,string,string")
    searchKey?: string, //email,userID, iccid
    searchValue?: string
  ): AxiosPromise<EsimInventoryTypeV2> {
    let convertedSearchCriteria = searchKey ? searchKey.toLowerCase() : ''
    if (searchKey === 'Customer ID') {
      convertedSearchCriteria = 'userID'
    }
    const searchQueryParam =
      searchKey && searchValue
        ? `&${convertedSearchCriteria}=${searchValue}`
        : ''
    const statusParam =
      statuses && statuses.length > 0 ? `&statuses=${statuses}` : ''

    return FaberApi.httpGet(
      `/esim/inventoriesV2?offset=${offset}&limit=${limit}${statusParam}${searchQueryParam}`,
      {
        Authorization: `Bearer ${faberToken}`
      }
    )
  }
}

export default InventoryAPI
